import { create } from 'zustand';
import type { SessionOut } from '@/api/charging';

interface SessionState {
  active: SessionOut | null;
  setActive: (session: SessionOut | null) => void;
}

export const useSessionStore = create<SessionState>((set) => ({
  active: null,
  setActive: (session) => set({ active: session })
}));
